module.exports = __webpack_public_path__ + "media/images/new_marketing/blue_button-5dbf9cb7579e83f77ae296e8ab16868ae811a901fa98bbb229692ddcb9c354ff.png";